import React, { memo } from "react";

import { Button } from "components/Buttons";
import { ButtonType } from "types/ui";
import { formatTimeFromUtc } from "utils/formatters";
import { getYearsFromUtc } from "utils/general";
import { ScoreDelta } from "components/ScoreDelta/ScoreDelta";
import { Region } from "types/Region";
import { ScoreConfig } from "types/PatientRegion";

type Props = {
  firstName: string;
  patientImage: string;
  lastName: string;
  dateOfBirth: string;
  region: Region;
  scores?: ScoreConfig;
  week: number;
  lastExam?: string | null;
};

export const PatientTableRow = memo(
  ({
    firstName,
    patientImage,
    lastName,
    dateOfBirth,
    region,
    scores,
    week,
    lastExam,
  }: Props) => {
    return (
      <div className="group w-full min-h-[54px] card rounded-xl flex items-center pl-3 font-normal text-grayDark hover:bg-bgDark hover:text-white hover:shadow-xl">
        <div className="w-[88px] pl-3">
          <div className="w-4 h-4 bg-red-600 rounded-full" />
        </div>
        <div className="w-[178px] flex items-center space-x-3 ">
          <div className="w-[30px] h-[30px] bg-grayDark rounded-full overflow-hidden">
            <img className="object-cover min-w-full min-h-full"
              src={patientImage}
              alt="avatar w-4 h-4 bg-red-600 rounded-full"
            />
          </div>

          <p>
            {firstName} {lastName}
          </p>
        </div>
        <div className="w-[103px] pl-2">
          {dateOfBirth ? <p>{getYearsFromUtc(dateOfBirth)}</p> : <p>---</p>}
        </div>
        <div className="w-[114px]">
          <p className="capitalize">
            {region.joint.side} {region.joint.name}
          </p>
        </div>
        <div className="w-[134px] pl-[32px]">
          <div className="flex flex-row items-baseline space-x-2">
            <p>{scores?.currentValue || "---"}</p>
            {scores?.delta && (
              <ScoreDelta delta={scores?.delta} isBetter={scores?.isBetter} />
            )}
          </div>
        </div>
        <div className="w-[96px]">
          <p>{week}</p>
        </div>
        <div className="w-[113px]">
          {lastExam ? <p>{formatTimeFromUtc(lastExam)}</p> : <p>---</p>}
        </div>
        <div>
          <Button
            title="Push to EHR"
            onClick={() => {}}
            classNames="group-hover:border-white"
            type={ButtonType.outline}
          />
        </div>
      </div>
    );
  }
);
